import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { formatPrice } from '../../../../utils';
import { handleNumericKeyDown, customSelectStyles } from '../OrderFormUtils';

const TulKanatForm = ({
  newOrder,
  onFieldChange,
  isLoading,
  productItems,
  productOptions,
  handleProductSelect,
  localPileModels,
  adminSettings,
  selectedProductType
}) => {
  return (
    <>
      <div className="form-group">
        <label>Oda Adı *</label>
        <input
          type="text"
          value={newOrder.roomName || ''}
          onChange={(e) => onFieldChange('roomName', e.target.value)}
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label>Ürün Adı *</label>
        <CreatableSelect
          options={productOptions}
          value={
            productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
            (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
          }
          onChange={(option) => {
            if (!option) {
              onFieldChange('productName', '');
              onFieldChange('unitPrice', '');
            } else if (option.__isNew__) {
              onFieldChange('productName', option.value);
              onFieldChange('unitPrice', '');
            } else {
              handleProductSelect(option.value);
            }
          }}
          isDisabled={isLoading}
          isClearable
          isSearchable
          placeholder="Ürün seçin veya yazın..."
          noOptionsMessage={() => "Ürün bulunamadı"}
          formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`}
          styles={customSelectStyles}
        />
      </div>

      <div className="form-group">
        <label>Ürün Varyantı</label>
        <input
          type="text"
          value={newOrder.productVariant || ''}
          onChange={(e) => onFieldChange('productVariant', e.target.value)}
          disabled={isLoading}
          placeholder="Renk, desen vb. giriniz..."
        />
      </div>

      <div className="form-group">
        <label>En (cm) *</label>
        <input
          type="number"
          step="0.01"
          value={newOrder.width || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('width', e.target.value)}
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label>Boy (cm) *</label>
        <input
          type="number"
          step="0.01"
          value={newOrder.height || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('height', e.target.value)}
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label>Birim Fiyat (₺) *</label>
        <input
          type="number"
          step="0.01"
          min="0"
          value={newOrder.unitPrice || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => {
            const newPrice = e.target.value;
            onFieldChange('unitPrice', newPrice);
            if (selectedProductType === 'tul' || selectedProductType === 'kanat') {
              let extra = 0;
              if (newOrder.pileModel === 'S Pile') extra = Number(adminSettings.sPilePrice) || 0;
              if (newOrder.pileModel === "Amerikan Pile 2'li") extra = Number(adminSettings.american2Price) || 0;
              if (newOrder.pileModel === "Amerikan Pile 3'lü") extra = Number(adminSettings.american3Price) || 0;
              onFieldChange('baseUnitPrice', (Number(newPrice) || 0) - extra);
            }
          }}
          required
          disabled={isLoading}
        />
      </div>

      <div className="form-group">
        <label>Pile Modeli *</label>
        <select
          value={newOrder.pileModel || ''}
          onChange={(e) => {
            const selectedModel = e.target.value;
            onFieldChange('pileModel', selectedModel);

            if (selectedProductType === 'tul' || selectedProductType === 'kanat') {
              let base = newOrder.baseUnitPrice;
              if (base === undefined || base === '' || base === null) {
                let oldExtra = 0;
                if (newOrder.pileModel === 'S Pile') oldExtra = Number(adminSettings.sPilePrice) || 0;
                if (newOrder.pileModel === "Amerikan Pile 2'li") oldExtra = Number(adminSettings.american2Price) || 0;
                if (newOrder.pileModel === "Amerikan Pile 3'lü") oldExtra = Number(adminSettings.american3Price) || 0;
                
                base = (Number(newOrder.unitPrice) || 0) - oldExtra;
                onFieldChange('baseUnitPrice', base);
              }

              let extra = 0;
              if (selectedModel === 'S Pile') extra = Number(adminSettings.sPilePrice) || 0;
              if (selectedModel === "Amerikan Pile 2'li") extra = Number(adminSettings.american2Price) || 0;
              if (selectedModel === "Amerikan Pile 3'lü") extra = Number(adminSettings.american3Price) || 0;
              
              onFieldChange('unitPrice', Number(base) + extra);
            }
          }}
          required
          disabled={isLoading}
        >
          <option value="">Pile modeli seçin</option>
          {localPileModels.map((model) => (
            <option key={model.id} value={model.modelName}>
              {model.modelName}
            </option>
          ))}
        </select>
      </div>

      {newOrder.pileModel && (
        <div className="form-group">
          <label>Pile Sıklığı</label>
          <input
            type="number"
            step="0.1"
            min="0.1"
            value={newOrder.pileDensity || ''}
            onChange={(e) => onFieldChange('pileDensity', e.target.value)}
            disabled={isLoading}
            placeholder="Pile sıklığı"
          />
          <small>Pile sıklığını düzenleyebilirsiniz</small>
        </div>
      )}

      {newOrder.width && newOrder.usedM2 && (
        <div className="form-group">
          <label>Kullanılan Mt</label>
          <input
            type="text"
            value={newOrder.usedM2}
            readOnly
            className="readonly-field"
          />
        </div>
      )}

      <div className="form-group">
        <label>Ek Ücret (₺)</label>
        <input
          type="number"
          step="0.01"
          min="0"
          value={newOrder.extraPrice || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('extraPrice', e.target.value)}
          disabled={isLoading}
        />
      </div>

      {newOrder.pileModel === 'Kapsül Pile' && (
        <>
          <div className="form-group">
            <label>Kapsül Birim Fiyat (₺) *</label>
            <input
              type="number"
              step="0.01"
              value={newOrder.capsuleUnitPrice && newOrder.capsuleUnitPrice !== 0 && newOrder.capsuleUnitPrice !== '0' ? newOrder.capsuleUnitPrice : ''}
              onChange={(e) => onFieldChange('capsuleUnitPrice', e.target.value)}
              required
              disabled={isLoading}
              placeholder="0.00"
            />
          </div>

          {newOrder.width && newOrder.capsulePrice && newOrder.capsulePrice !== 0 && newOrder.capsulePrice !== '0' && (
            <div className="form-group">
              <label>Kapsül Ücreti (₺)</label>
              <input
                type="text"
                value={formatPrice(newOrder.capsulePrice)}
                readOnly
                className="readonly-field"
              />
            </div>
          )}
        </>
      )}

      <div className="form-group">
        <label>Adet *</label>
        <input
          type="number"
          min="1"
          value={newOrder.quantity || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('quantity', e.target.value)}
          required
          disabled={isLoading}
          placeholder="Adet giriniz"
        />
      </div>

      <div className="form-group">
        <label>İskonto (%)</label>
        <input
          type="number"
          min="0"
          max="100"
          value={newOrder.discount || ''}
          onKeyDown={handleNumericKeyDown}
          onChange={(e) => onFieldChange('discount', e.target.value)}
          disabled={isLoading}
        />
      </div>

      {newOrder.productName && (
        <div className="form-group">
          <label>Toplam Tutar (₺)</label>
          <input
            type="text"
            value={formatPrice(newOrder.totalPrice)}
            readOnly
            className="readonly-field total-price"
          />
        </div>
      )}

      {newOrder.discount > 0 && (
        <div className="form-group">
          <label>İndirimli Tutar (₺)</label>
          <input
            type="text"
            value={formatPrice(newOrder.discountedPrice)}
            readOnly
            className="readonly-field discounted-price"
          />
        </div>
      )}

    </>
  );
};

export default TulKanatForm;
